<template>
<div class="chapter">
<div class="inner_page">
<p class="blq1"><i>“After it was all over I said some prayers for them, from the hymn book. That was the least that I could do.”</i></p>
<p class="blq-right2">—From a lengthy confession letter John Emil List left behind for his pastor before fleeing the home where he murdered his wife, his three children, and his mother</p>
<p class="blq1"><i>“The concept of the psychopath is, in fact, an admission of failure to solve the mystery of evil. It is merely a restatement of the mystery—and only offers an escape valve for the frustration felt by psychiatrists, social workers, and police officers, who daily encounter its force.”</i></p>
<p class="blq-right2">—Janet Malcolm, <i>The Journalist and the Murderer</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?d9e1689e